'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/5/18.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _GoeasyRadio = require('../GoeasyInputField/GoeasyRadio');

var _GoeasyRadio2 = _interopRequireDefault(_GoeasyRadio);

var _reactRadio = require('react-radio');

var _reactRadio2 = _interopRequireDefault(_reactRadio);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersonalInfoChange = (_dec = (0, _reduxForm.reduxForm)({
  form: 'personalInfoChange',
  fields: ['nickname', 'name', 'email', 'mobile', 'gender', 'intro']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PersonalInfoChange, _Component);

  function PersonalInfoChange() {
    (0, _classCallCheck3.default)(this, PersonalInfoChange);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalInfoChange).apply(this, arguments));
  }

  (0, _createClass3.default)(PersonalInfoChange, [{
    key: 'onGenderChange',
    value: function onGenderChange(value) {
      var gender = this.props.fields.gender;

      gender.onChange(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./PersonalInfoChange.scss');
      var _props = this.props;
      var _props$fields = _props.fields;
      var nickname = _props$fields.nickname;
      var name = _props$fields.name;
      var email = _props$fields.email;
      var mobile = _props$fields.mobile;
      var gender = _props$fields.gender;
      var intro = _props$fields.intro;
      var handleSubmit = _props.handleSubmit;
      var labelStyle = _props.labelStyle;

      var inputLabelStyle = {};
      if (labelStyle) {
        inputLabelStyle = (0, _extends3.default)({}, labelStyle);
      }
      /*
       const genderDiv = (<div className={styles.gender}><label className={styles.name_label}
       style={labelStyle ? labelStyle : { fontSize: '14px' }}>性别：</label>
       <div className={styles.radioDiv}>
       <input type="radio" className={styles.radio}
       id={'gender_01'} {...gender}
       value="男"
       checked={gender.value === '男'}/>
       <label htmlFor="gender_01">男</label>
       <input type="radio"
       id={'gender_02'} {...gender}
       value="女"
       checked={gender.value === '女'}/>
       <label htmlFor="gender_02">女</label></div>
       <div className="clear"></div>
       </div>);*/
      return _react2.default.createElement(
        'form',
        { className: styles.component, onSubmit: handleSubmit },
        _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '昵称：', inputPlaceholder: '', formProps: nickname }),
        _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '真实姓名：', inputPlaceholder: '', formProps: name }),
        _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '用户邮箱：', inputPlaceholder: '', formProps: email }),
        _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '联系电话：', inputPlaceholder: '', formProps: mobile }),
        _react2.default.createElement(
          'div',
          { style: { marginTop: '20px' } },
          _react2.default.createElement(
            'label',
            { className: styles.label },
            '性别：'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.input },
            _react2.default.createElement(
              _reactRadio2.default,
              { name: 'gender', value: gender.value,
                onChange: this.onGenderChange.bind(this) },
              _react2.default.createElement(_GoeasyRadio2.default, { Id: 'gender_male', currentData: { value: '男', label: '男' },
                customStyle: { float: 'left', marginLeft: '10px' },
                fieldsType: gender }),
              _react2.default.createElement(_GoeasyRadio2.default, { Id: 'address_female', currentData: { value: '女', label: '女' },
                customStyle: { float: 'left', marginLeft: '10px' },
                fieldsType: gender })
            )
          ),
          _react2.default.createElement('div', { className: 'clear' })
        ),
        _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, inputType: 'textarea', label: '简介：', inputPlaceholder: '',
          formProps: intro }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_SubmitBtn2.default, { btnClick: handleSubmit, text: '确定' })
      );
    }
  }]);
  return PersonalInfoChange;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,
  labelStyle: _react.PropTypes.object
}, _temp)) || _class);
exports.default = PersonalInfoChange;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PersonalInfoChange/PersonalInfoChange.js
 ** module id = 1400
 ** module chunks = 0
 **/